import {
  Component,
  OnInit,
  Input,
  OnChanges,
  SimpleChange,
  Output,
  EventEmitter,
} from '@angular/core';
import { NavController } from 'ionic-angular';
import { MessengerProvider } from '../../providers/messenger/messenger';
import { GlobalNotificationsProvider } from '../../providers/providers';
import { Data, Notes } from './../../models/notes.model';

/**
 * Generated class for the MessengerNotesComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'messenger-notes',
  templateUrl: 'messenger-notes.html',
})
export class MessengerNotesComponent implements OnInit {
  @Input('search') search: string = '';
  @Input('refresh') refresh;
  @Output() changeSegment: EventEmitter<string> = new EventEmitter<string>();

  notes: Data[];
  text: string;
  page = 0;
  pageSize = 15;
  totalPages: number = 0;

  constructor(
    private navCtrl: NavController,
    private messengerProvider: MessengerProvider,
    private globalNotifications: GlobalNotificationsProvider
  ) {}

  ngOnInit(): void {
    this.loadNotes('');
  }
  ngOnChanges(changes: SimpleChange) {
    if (changes['refresh'] !== undefined || changes['search'] !== undefined) {
      this.page = 0;
      this.loadNotes(this.search);
    }
  }

  loadNotes(query): void {
    this.messengerProvider
      .getAllNotes(query, this.page, this.pageSize)
      .subscribe((response: Notes) => {
        this.notes = response.data;
        this.page = response.pageNumber + 1;
        this.totalPages = response.totalPages;
      });
  }

  viewNotes(contact: any): void {
    //contact.uuid = contact.contactUuid;
    this.navCtrl.push('NotePage', {
      user: contact,
    });
  }

  doInfinite(infiniteScroll) {
    this.page++;
    setTimeout(() => {
      this.messengerProvider
        .getAllNotes(this.search, this.page, this.pageSize)
        .subscribe(res => {
          const data = res.data;
          this.totalPages = res.totalPages;
          this.notes.push(...res.data);
          infiniteScroll.complete();
        });
    }, 0);
  }

  goToContacts(): void {
    this.changeSegment.emit('contacts');
  }
}



// WEBPACK FOOTER //
// ./src/components/messenger-notes/messenger-notes.ts